import React from 'react';

import { useFormContext } from 'react-hook-form';
import { Collapse, Grid } from '@mui/material';

import { DispatchEventReport, ReportType } from '../../../core/api/clients';
import AttachmentList from '../../../components/AttachmentList';
import ControlledTextField from '../../../components/ControlledTextField';
import { useDispatchEventReportData } from '../../../core/context/DispatchEventReportDataContext';

function NarrativeStep({ visible, readOnly }: { visible: boolean, readOnly?: boolean }) {
  const { control } = useFormContext<DispatchEventReport>();
  const { dispatchEventReport, allowedActions } = useDispatchEventReportData();

  return (
    <Collapse in={visible}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ControlledTextField<DispatchEventReport>
            control={control}
            name="narrative"
            TextFieldProps={{
              multiline: true,
              rows: 6,
            }}
            readOnly={readOnly}
            rules={{ required: (!(dispatchEventReport.safetyNarrative && dispatchEventReport.safetyNarrative.length > 0)) }}
            disableEditPopper={!allowedActions?.edit}
          />
        </Grid>
        <Grid item xs={12}>
          <AttachmentList
            reportType={ReportType.DispatchEventReport}
            reportId={dispatchEventReport.id}
            allowedActions={allowedActions}
          />
        </Grid>
      </Grid>
    </Collapse>
  );
}

export default NarrativeStep;
